"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Assets/Parameters Service
 * Set from Package Json
 *
 * The version of the OpenAPI document: 1.125.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterTypeSchemaDataTypeEnum = void 0;
exports.ParameterTypeSchemaDataTypeEnum = {
    Boolean: 'boolean',
    Date: 'date',
    Float: 'float',
    Integer: 'integer',
    String: 'string',
    Number: 'number'
};
